import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import { LOCALE_LOADING, LOCALE, LOCALE_ERROR } from 'actions/localization';

const INITIAL_STATE = Immutable({
  loading: false,
  error: null,
  messages: {},
  locale: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case LOCALE_LOADING:
      return state.merge({
        loading: true,
        error: null,
      });
    case LOCALE: {
      if (
        action.payload &&
        action.payload.length &&
        action.payload[0].default
      ) {
        return state.merge({
          messages: action.payload[0].default,
          locale: action.meta,
          loading: false,
          error: null,
        });
      }
      return state.merge({
        loading: false,
        error: action.payload.message,
      });
    }
    case LOCALE_ERROR:
      return state.merge({
        loading: false,
        error: action.payload,
      });
    default:
      return state;
  }
};
